import gameConfig from "@/common/config/games"
import { getGameIntegration } from "@/common/config/game-integrations"
import gameStandards from "@/common/config/game-standards.json"

var DEFAULT_IMAGE = "/static/files/p/ic_launcher120.png"
var GAME_ASSET_BASE_URL = String(process.env.GAME_ASSET_BASE_URL || "").replace(/\/$/, "")
var GAME_HOST_ALLOWED_ORIGINS = String(process.env.GAME_HOST_ALLOWED_ORIGINS || "").trim()
var LOCAL_GAMES_PREFIX = gameStandards.localGamesPrefix

function normalizeImage(image) {
  var value = String(image || "")

  if (!value || /\/\.(png|jpe?g|webp|gif)$/i.test(value)) {
    return DEFAULT_IMAGE
  }

  return value
}

function cleanDesc(desc) {
  return String(desc || "")
    .replace(/<br\s*\/?>/gi, " ")
    .replace(/\s+/g, " ")
    .trim()
}

function slugify(value) {
  return String(value || "")
    .trim()
    .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
}

function ensureLeadingSlash(path) {
  var value = String(path || "")
  if (!value) {
    return "/"
  }

  return value.charAt(0) === "/" ? value : "/" + value
}

function ensureTrailingSlash(path) {
  var value = String(path || "")
  if (!value) {
    return "/"
  }

  return value.charAt(value.length - 1) === "/" ? value : value + "/"
}

function joinUrl(base, path) {
  if (!base) {
    return path
  }

  return base.replace(/\/$/, "") + "/" + String(path || "").replace(/^\//, "")
}

function stripLocalGamesPrefix(path) {
  var value = ensureLeadingSlash(path)
  if (value.indexOf(LOCAL_GAMES_PREFIX) === 0) {
    return value.slice(LOCAL_GAMES_PREFIX.length)
  }

  return value.replace(/^\//, "")
}

function resolveAssetDirectory(game) {
  if (game && game.assetDirectory) {
    return String(game.assetDirectory).replace(/^\/+|\/+$/g, "")
  }

  return slugify(game && (game.id || game.name || "game"))
}

function resolveAssetRootUrl(game) {
  var path = game && game.path
  var directoryPath = ensureTrailingSlash(path)

  if (/^https?:\/\//i.test(directoryPath)) {
    return directoryPath
  }

  if (GAME_ASSET_BASE_URL && directoryPath.indexOf(LOCAL_GAMES_PREFIX) === 0) {
    return joinUrl(GAME_ASSET_BASE_URL, resolveAssetDirectory(game)) + "/"
  }

  return directoryPath
}

function resolveEntryUrl(game, entryFile) {
  return joinUrl(resolveAssetRootUrl(game), entryFile || gameStandards.entryFile)
}

function buildHostedGameUrl(item) {
  // Native mode: load game directly without game-host.html wrapper
  // This allows games with their own SDK mocks to work properly
  if (item.integrationMode === "native") {
    return item.entryUrl
  }

  var params = new URLSearchParams({
    game: item.entryUrl,
    assetRoot: item.assetRootUrl,
    gameId: item.id,
    engine: item.engine,
    orientation: item.orientation,
    sdkProfile: item.sdkProfile
  })

  if (GAME_HOST_ALLOWED_ORIGINS) {
    params.set("allowedHosts", GAME_HOST_ALLOWED_ORIGINS)
  }

  return "/static/game-host.html?" + params.toString()
}

function normalizeGame(game) {
  var integration = getGameIntegration(game.id)
  var item = Object.assign({}, integration, game)
  item.slug = slugify(game.name || game.id)
  item.assetDirectory = resolveAssetDirectory(item)
  item.cleanDesc = cleanDesc(game.desc)
  item.image = normalizeImage(item.image)
  item.assetRootUrl = resolveAssetRootUrl(item)
  item.entryUrl = resolveEntryUrl(item, item.entryFile)
  item.gamePath = item.entryUrl
  item.hostedPath = buildHostedGameUrl(item)
  return item
}

function getGameList() {
  return Object.keys(gameConfig.games).map(function(key) {
    return normalizeGame(gameConfig.games[key])
  })
}

function getGameBySlug(slug) {
  return getGameList().find(function(game) {
    return game.slug === slug
  }) || null
}

function getGameById(id) {
  return getGameList().find(function(game) {
    return game.id === id
  }) || null
}

export {
  cleanDesc,
  getGameById,
  getGameBySlug,
  getGameList,
  normalizeGame,
  slugify
}



// WEBPACK FOOTER //
// ./src/common/games.js